// Page loads, single-page-app route changes (History API), hash changes and tab visibility.

import { shortUrl } from '../net-utils.js';

export function installNavigation(ctx, win = window, doc = document) {
  const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
  ctx.push('navigation', 'info', `Page loaded ${shortUrl(ctx.redact.url(location.href))}`, {
    url: ctx.redact.url(location.href),
    referrer: doc.referrer ? ctx.redact.url(doc.referrer) : undefined,
    type: nav ? nav.type : undefined,
  });

  const record = (method, url) => {
    try {
      const href = new URL(url === undefined || url === null ? location.href : String(url), location.href).href;
      ctx.push('navigation', 'info', `Navigated to ${shortUrl(ctx.redact.url(href))}`, {
        url: ctx.redact.url(href),
        method,
      });
    } catch {
      // ignore
    }
  };

  for (const method of ['pushState', 'replaceState']) {
    const original = win.history[method];
    if (typeof original !== 'function') continue;
    win.history[method] = function (state, title, url) {
      const result = original.apply(this, arguments);
      if (url !== undefined && url !== null) record(method, url);
      return result;
    };
  }

  win.addEventListener('popstate', () => record('popstate'));
  win.addEventListener('hashchange', () => record('hashchange'));
  doc.addEventListener('visibilitychange', () => {
    ctx.push('page', 'debug', doc.visibilityState === 'hidden' ? 'Tab hidden' : 'Tab visible', {
      visibilityState: doc.visibilityState,
    });
  });
}
